import { useState, useEffect, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { Input } from "design-react-kit";
import { isSelectQuery, SELECT_QUERY_ERROR } from "../../Utility/reportQuery";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditReport(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [report, setReport] = useState();
  const [loading, setLoading] = useState(true);
  const [queryError, setQueryError] = useState("");
  const [apiError, setApiError] = useState("");

  const query = useQuery();

  useEffect(() => {
    setLoading(false);
    const id = query.get("report");
    if (id != null) {
      Repo.getReportById(apiToken, id)
        .then((response) => {
          setReport(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    } else {
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reportEditValidation = () => {
    setValidation(true);
    setApiError("");
    let passedValidation = true;

    if (!report?.title) passedValidation = false;
    if (!report?.description) passedValidation = false;
    if (!report?.query) {
      passedValidation = false;
      setQueryError("Il campo non può essere vuoto!");
    } else if (!isSelectQuery(report.query)) {
      passedValidation = false;
      setQueryError(SELECT_QUERY_ERROR);
    } else {
      setQueryError("");
    }

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const updateReportAPI = () => {
    Repo.postUpdateReport(apiToken, JSON.stringify(report))
      .then((response) => {
        if (response.status === 200) {
          window.location.href = props.subfolder + "/report";
        }
      })
      .catch((error) => {
        console.log(error);
        setApiError(
          error.response?.data?.Message ||
            error.response?.data?.message ||
            SELECT_QUERY_ERROR
        );
      });
  };

  return (
    <div>
      <h1>Modifica report</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Modifica titolo, descrizione e query del report. Sono ammesse solo
          query di tipo SELECT.
        </p>
      </div>

      {report && (
        <>
          <div className="row mt-3">
            <div className="col-lg-12">
              <Input
                id="title"
                required
                label="Titolo*"
                type="text"
                name="title"
                value={report.title || ""}
                {...(validation &&
                  !report.title && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                onChange={(e) =>
                  setReport({ ...report, title: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-lg-12">
              <Input
                id="description"
                required
                label="Descrizione*"
                type="text"
                name="description"
                value={report.description || ""}
                {...(validation &&
                  !report.description && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                onChange={(e) =>
                  setReport({ ...report, description: e.target.value })
                }
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-lg-12">
              <label htmlFor="query">Query*</label>
              <textarea
                id="query"
                name="query"
                className={`form-control${
                  validation && queryError ? " is-invalid" : ""
                }`}
                rows={12}
                value={report.query || ""}
                onChange={(e) => {
                  setQueryError("");
                  setReport({ ...report, query: e.target.value });
                }}
              />
              {validation && queryError && (
                <small className="text-danger">{queryError}</small>
              )}
            </div>
          </div>

          {apiError && (
            <div className="alert alert-danger mt-2" role="alert">
              <b>{apiError}</b>
            </div>
          )}

          <div className="row my-2">
            <div className="col-lg-12 text-right">
              <button
                type="button"
                className="btn btn-primary"
                data-toggle="tooltip"
                data-placement="top"
                onClick={reportEditValidation}
                title="Conferma"
              >
                Conferma
              </button>
            </div>
          </div>
        </>
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica report"
        body="Confermi di voler aggiornare il report selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={updateReportAPI}
      />
      {!loading && <Loader></Loader>}
    </div>
  );
}

export default EditReport;
